import { Trans } from '@lingui/macro'
import { type Model } from 'jms-domain'

import { ChildEntityToggleSelector } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

interface LynxProfessionalOutdoorBeverageDispenserPropertyPageProps {
  id: Model.LynxProfessionalOutdoorBeverageDispenserW24['id']
}

export const LynxProfessionalOutdoorBeverageDispenserPropertyPage = (
  props: LynxProfessionalOutdoorBeverageDispenserPropertyPageProps
) => {
  const { id } = props

  return (
    <PropertyContainer.Group spacing="large">
      <PropertyContainer.Item title={<Trans>Tower Kit</Trans>}>
        <ChildEntityToggleSelector entityId={id} instanceName="towerKit" />
      </PropertyContainer.Item>
    </PropertyContainer.Group>
  )
}
